export default __webpack_public_path__ + "static/media/KYCAMLCTF.88f0c2b5.svg";